var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.45455C8 3.15341 7.75568 2.90909 7.45455 2.90909H5.09091V0.545455C5.09091 0.244318 4.84659 0 4.54545 0H3.45455C3.15341 0 2.90909 0.244318 2.90909 0.545455V2.90909H0.545455C0.244318 2.90909 0 3.15341 0 3.45455V4.54545C0 4.84659 0.244318 5.09091 0.545455 5.09091H2.90909V7.45455C2.90909 7.75568 3.15341 8 3.45455 8H4.54545C4.84659 8 5.09091 7.75568 5.09091 7.45455V5.09091H7.45455C7.75568 5.09091 8 4.84659 8 4.54545V3.45455Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fb18ca84e4902d27b561b0f09579deeb.svg";
export { ForwardRef as ReactComponent };